const SERVER_IP_LOCAL = "localhost:3977";
const SERVER_IP =
  "educa360-api-service.8ft4nnnxq52hr.eu-central-1.cs.amazonlightsail.com";
let DEVELOPMENT = false;

const BASE_PATH = DEVELOPMENT
  ? `http://${SERVER_IP_LOCAL}`
  : `https://${SERVER_IP}`;
const BASE_API = DEVELOPMENT
  ? `http://${SERVER_IP_LOCAL}/api/v1`
  : `https://${SERVER_IP}/api/v1`;
const HUB_PATH = "https://educa360.org";
export const ENV = {
  HUB_PATH: HUB_PATH,
  BASE_PATH: BASE_PATH,
  BASE_API: BASE_API,
  TINY_APIKEY: "ut2heklvdce2gq2j6jof2lt06of8het88r0nlw3jtxwr9eck",
  PATH_GLB:
    "https://repopublic-educa360-central.s3.eu-central-1.amazonaws.com/adminweb/glb/",
  API_ROUTES: {
    REGISTER: "auth/register",
    VERIFY: "auth/verify",
    RESEND_CODE: "auth/resendCode",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    USER_ME: "user/me",
    USER: "user",
    USERS: "users",
    MENU: "menu",
    COURSE: "course",
    COURSES: "courses",
    NEWSLETTER: "newsletter",
    POSTS: "posts",
    POST: "post",
    ASSISTANCE: "assistance",
    ASSISTANCES: "assistances",
    THREAD: "thread",
    THREADPUBLIC: "threadPublic",
    THREADGET: "threadGet",
    CLIENTDB: "clientdb",
    CLIENTSDB: "clientsdb",
    THREEJSIA: "threejs",
    GETTEXT_TO_SPEECH: "speechToText",
    SCENEFILE: "virtualscene/uploadimage",
    SCENEREPO: "virtualscene/uploadrepo",
    HUBROOMS: "roomshub",
    LOADROOMS: "roomshub/load",
    CONTACT: "contacts", //HOLDED CREATE CONTACT
    INSTITUTION: "institution", //HOLDED CREATE INSTITUTION
    PLANS: "plans",
    PLAN_ACTIVATIONS: "planactivations",
  },
  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
  USER: {
    ID: "id",
    CODE: "code",
  },
  homepage: "https://api.educajob.net/",
};
